import type { FlightSetDetail } from "../api/types";

export interface SetNavChipProps {
  set: FlightSetDetail;
  currentFlightId: string;
  onNavigate: (flightId: string) => void;
}

const btnStyle: React.CSSProperties = {
  background: "#1a1a1a",
  color: "#eee",
  border: "1px solid #333",
  borderRadius: 4,
  padding: "2px 8px",
  fontSize: 14,
  lineHeight: 1,
  cursor: "pointer",
};

export function SetNavChip(
  { set, currentFlightId, onNavigate }: SetNavChipProps,
): JSX.Element | null {
  if (set.members.length < 2) return null;
  const idx = set.members.findIndex((m) => m.flightId === currentFlightId);
  if (idx === -1) return null;
  const prev = set.members[idx - 1];
  const next = set.members[idx + 1];
  return (
    <span data-tour="viewer.set" style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      <button
        type="button"
        aria-label="Previous flight in set"
        disabled={prev === undefined}
        onClick={() => prev !== undefined && onNavigate(prev.flightId)}
        style={{ ...btnStyle, opacity: prev === undefined ? 0.4 : 1 }}
      >
        &#8249;
      </button>
      <span
        style={{
          fontSize: 13,
          color: "#bbb",
          border: "1px solid #333",
          borderRadius: 999,
          padding: "3px 10px",
          whiteSpace: "nowrap",
        }}
      >
        {`${set.name} · ${idx + 1} of ${set.members.length}`}
      </span>
      <button
        type="button"
        aria-label="Next flight in set"
        disabled={next === undefined}
        onClick={() => next !== undefined && onNavigate(next.flightId)}
        style={{ ...btnStyle, opacity: next === undefined ? 0.4 : 1 }}
      >
        &#8250;
      </button>
    </span>
  );
}
